/**
 * Get CSRF token from cookies (Django's standard approach)
 */
const getCSRFToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
};

const PDFPrint = () => {
    const printBtn = document.getElementById('pdf-print-btn');
    if (!printBtn) return;

    printBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        const pageId = this.dataset.pageId;

        // Collect expanded block IDs
        // Look for accordion elements where the collapsed-content is NOT hidden
        const expandedBlocks = [];
        document.querySelectorAll('.accordion').forEach(accordion => {
            const content = accordion.querySelector('.collapsed-content');
            if (content && !content.classList.contains('hidden')) {
                // Get the identifier - prefer anchor_id if set, otherwise use section-N
                const anchorId = accordion.id;
                const flexBlock = accordion.closest('.flex-block');
                const sectionId = flexBlock ? flexBlock.id : null;

                // Use anchor_id if available, otherwise fall back to section ID
                const identifier = anchorId || sectionId;
                if (identifier) {
                    expandedBlocks.push(identifier);
                }
            }
        });

        // Show loading state
        const originalContent = this.innerHTML;
        this.innerHTML = '<span>Génération PDF...</span>';
        this.disabled = true;

        try {
            const response = await fetch(`/api/flex/${pageId}/pdf/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCSRFToken()
                },
                body: JSON.stringify({ expanded_blocks: expandedBlocks })
            });

            if (!response.ok) {
                throw new Error('PDF generation failed');
            }

            // Get the filename from Content-Disposition header if available
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'document.pdf';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('PDF generation error:', error);
            alert('Erreur lors de la génération du PDF. Veuillez réessayer.');
        } finally {
            this.innerHTML = originalContent;
            this.disabled = false;
        }
    });
};

export default PDFPrint;
